import {
	IAllIssue,
	PRODUCT_DISPLAY_NAME,
	PRODUCT_NAME
} from 'src/apps/dashboard/pages/issues/types/IssuesTypes';

import { GetAllIssuesQuery } from '../AllIssues.generated';

export interface IAllIssuesResult {
	issues: IAllIssue[];
	totalCount: number;
	unfilteredTotal: number;
}

const productDisplayNameMap: Record<PRODUCT_NAME, PRODUCT_DISPLAY_NAME> = {
	[PRODUCT_NAME.WEB_FLOW_ANALYZER]: PRODUCT_DISPLAY_NAME.WEB_FLOW_ANALYZER,
	[PRODUCT_NAME.WEB_SDK]: PRODUCT_DISPLAY_NAME.WEB_SDK
};

const productNameMap: Record<string, PRODUCT_NAME> = {
	WEB_FLOW_ANALYZER: PRODUCT_NAME.WEB_FLOW_ANALYZER,
	WEB_SDK: PRODUCT_NAME.WEB_SDK
};

const getProductDisplayName = (productName: string): PRODUCT_DISPLAY_NAME => {
	const normalizedProductName = getProductName(productName);
	return productDisplayNameMap[normalizedProductName];
};

const getProductName = (productName: string): PRODUCT_NAME => {
	return productNameMap[productName] ?? PRODUCT_NAME.WEB_SDK;
};

export const transformAllIssuesResults = (result: GetAllIssuesQuery): IAllIssuesResult => {
	const issues = result?.core_label_issues || [];
	const totalArray = result?.total || [];
	const unfilteredTotalArray = result?.unfilteredTotal || [];

	const transformedIssues: IAllIssue[] = issues
		.filter((issue): issue is NonNullable<typeof issue> => issue !== null)
		.map((issue) => ({
			id: issue.issue_id,
			runId: issue.run_id,
			productName: getProductName(issue.product_name),
			issueType: issue.type_name,
			severity: issue.severity_name,
			pageTitle: issue.page_title,
			pageUrl: issue.url,
			foundBy: getProductDisplayName(issue.product_name),
			sessionOrTest: issue.session_name || '',
			user: issue.user_name || ''
		}));

	const totalCount = totalArray[0]?.issue_id_count || 0;
	const unfilteredTotal = unfilteredTotalArray[0]?.issue_id_count || 0;

	return {
		issues: transformedIssues,
		totalCount,
		unfilteredTotal
	};
};
